import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EdgeFormComponent } from './edge-form/edge-form.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { EdgDuctFormComponent } from './edge-form/edge-duct-form/edge-duct-form.component';
import { EdgeDuctDiagramComponent } from './edge-form/edge-duct-diagram/edge-duct-diagram.component';
import { EdgeDuctDiagramDuctComponent } from './edge-form/edge-duct-diagram/edge-duct-diagram-duct/edge-duct-diagram-duct.component';
import { EdgeDuctDiagramSubductComponent } from './edge-form/edge-duct-diagram/edge-duct-diagram-subduct/edge-duct-diagram-subduct.component';

@NgModule({
  declarations: [
    EdgeFormComponent,
    EdgDuctFormComponent,
    EdgeDuctDiagramComponent,
    EdgeDuctDiagramDuctComponent,
    EdgeDuctDiagramSubductComponent
  ],
  imports: [
    CommonModule,
    SharedModule
  ]
})
export class EdgesModule { }
